import api from '../../services/axios';
import { bankConcepts } from '../../services/bankConcepts';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ReactAsyncSelect from "../controls/ReactAsyncSelect";
import Select from "react-select";
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/Button';
import getMovileurosAgents from '../../services/getMovileurosAgents';

const EditBankEntry = (props) => {

  const { t } = useTranslation();
  const navigate = useNavigate()
  const { id } = useParams()
  const [formParameters, setFormParameters] = useState({
    initialConcept: [],
    initialAgent: [],
    bank: '',
    date: '',
    comment: '',
    agentId: '',
    bankId: null,
    conceptId: null,
    amount: 0
  })
  const [errMsg, setErrMsg] = useState('');
  const [movileurosAgents, setMovileurosAgents] = useState([])

  const update = async (e) => {
    e.preventDefault();

    try {
      await api.put(`/bank_entries/${id}`, {
        //date: date,
        amount: formParameters.amount,
        bankComment: formParameters.comment,
        bankConceptId: formParameters.conceptId,
        agentId: formParameters.agentId,
        bankId: formParameters.bankId,
      }, {
        headers: {
          'Authorization': `Bearer ${props.loginParameters.accesToken}`
        }
      })
      navigate('/bank_entries')
    } catch (err) {
      if (!err?.response) {
        setErrMsg('No Server Response');
      } else if (err.response?.status === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.response?.status === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
    }
  }

  const goBack = async (e) => {
    e.preventDefault();
    navigate('/bank_entries')
  }

  useEffect(() => {
    const getbankEntryById = async () => {
      const response = await api.get(`/bank_entries/${id}`)
      setFormParameters({
        ...formParameters,
        initialAgent: {
          label: response.data.agent ? response.data.agent.income_code : null,
          value: response.data.agent ? response.data.agent.id : null
        },
        initialConcept: {
          label: response.data.concept ? response.data.concept.name : null,
          value: response.data.concept ? response.data.concept.id : null
        },
        date: response.data.date,
        agentId: response.data.agent ? response.data.agent.id : null,
        conceptId: response.data.concept ? response.data.concept.id : null,
        bank: response.data.bank.name,
        bankId: response.data.bank.id,
        comment: response.data.comment,
        amount: parseFloat(response.data.amount).toFixed(2)
      })
    }
    getbankEntryById()
  }, [])

  useEffect(() => {
    getMovileurosAgents(props.loginParameters.accesToken).then(movileurosAgents => setMovileurosAgents(movileurosAgents))
  }, [props.loginParameters.accesToken])

  // I have to wait for the initialAgent to load before randerizing
  if (formParameters.initialAgent.length === 0) return;

  return (
    <div style={{padding: "20px"}}>
      <h3  style={{"margin-bottom": "20px"}}>{t('banks.edit_bank_entry')}</h3>
      <form style={{"margin-left": "20px"}}>
        <div className='mb-3'>
          <label className='form-label'>{t('banks.bank')}</label>
          <input
            value={formParameters.bank}
            type='text'
            className='form-control'
            disabled
          />
        </div>
        <div className='mb-3'>
          <label className='form-label'>{t('banks.date')}</label>
          <input
            value={formParameters.date}
            type='text'
            className='form-control'
            disabled
          />
        </div>
        <div className='mb-3'>
          <label className='form-label'>{t('commercial_network.code')}</label>
          <Select
            options={movileurosAgents}
            onChange={(e) => setFormParameters({
              ...formParameters,
              agentId: e.value
            })}
            //onInputChange={() => setWantedAgent('')}
            isClearable
            defaultValue={formParameters.initialAgent}
          />
        </div>
        <div className='mb-3'>
          <label className='form-label'>{t('banks.concept')}</label>
          <ReactAsyncSelect
            initialOption={formParameters.initialConcept}
            handleChange={(e) => setFormParameters({
              ...formParameters,
              conceptId: e.value
            })}
            fetchData={bankConcepts}
          />
        </div>
        <div className='mb-3'>
          <label className='form-label'>{t('banks.comment')}</label>
          <input
            value={formParameters.comment}
            onChange={(e) => setFormParameters({
              ...formParameters,
              comment: e.target.value
            })}
            type='text'
            className='form-control'
          />
        </div>
        <div className='mb-3'>
          <label className='form-label'>{t('banks.amount')}</label>
          <input
            value={formParameters.amount}
            onChange={(e) => setFormParameters({
              ...formParameters,
              amount: e.target.value
            })}
            type='number'
            className='form-control'
            disabled
          />
        </div>
        <h4 className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</h4>

        <Button onClick={update} style={{margin: "5px", padding: "5px"}} type='submit' className='btn btn-primary'>{t('update')}</Button>
        <Button onClick={goBack} style={{margin: "5px", padding: "5px"}} type='submit' className='btn btn-primary'>{t('back')}</Button>
      </form>
    </div>
  );
};
export default EditBankEntry;